/** Right-rail board art for Player Pairing v5. Prefer local `/pairing/boards/*`. */

export const PAIRING_BOARD_NAMES = [
  'gym',
  'dessert',
  'breakfast',
  'retail',
  'salon',
  'heyman',
  'wings',
] as const;

export type PairingBoardName = (typeof PAIRING_BOARD_NAMES)[number];

const CDN = (name: PairingBoardName) =>
  `https://www.ghostscreens.com/_next/image?url=%2Fboards%2F${name}.png&w=1920&q=75`;

export function pairingBoardSrc(name: PairingBoardName): string {
  return `/pairing/boards/${name}.png`;
}

export function pairingBoardFallback(name: PairingBoardName): string {
  return CDN(name);
}

/** Faded wall grid — 20 tiles, same cycle as the design HTML. */
export function pairingWallTiles(): PairingBoardName[] {
  return Array.from({ length: 20 }, (_, i) => PAIRING_BOARD_NAMES[(i * 3) % 7]!);
}

export type FeaturedBoard = {
  name: PairingBoardName;
  className: string;
};

/** Absolute featured cards (positions via CSS classes). */
export const FEATURED_BOARDS: FeaturedBoard[] = [
  { name: 'breakfast', className: 'pairing-backdrop__card--breakfast' },
  { name: 'salon', className: 'pairing-backdrop__card--salon' },
  { name: 'heyman', className: 'pairing-backdrop__card--heyman' },
  { name: 'retail', className: 'pairing-backdrop__card--retail' },
  { name: 'wings', className: 'pairing-backdrop__card--wings' },
];
